<div class="phx-panel-messages-container">
    <phx-entity-chat-panel [entityTypeId]="entityType" [entityId]="entityId"></phx-entity-chat-panel>
</div>